import { render, staticRenderFns } from "./GTeachersImport.vue?vue&type=template&id=016ed46c&scoped=true&"
import script from "./GTeachersImport.vue?vue&type=script&lang=ts&"
export * from "./GTeachersImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ed46c",
  null
  
)

export default component.exports